import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps } from '../../../lib/types/types';
import { SelectComponent } from '../../FormInputs/Select/SelectComponent';

const ChangeLocaleComponent = ({ value, options, onChange }: InputSelectComponentProps) => {
    return (
        <div className="sid-change-locale">
            <div className="sid-field__label sid-change-locale__label ">
                <FormattedHTMLMessage id="changeLanguage"
                    defaultMessage="Change language"
                />
            </div>
                <SelectComponent
                    className="sid-change-locale__select"
                    hideDropDownButton={true}
                    options={ options }
                    onChange={ (locale: FormSelectChoice) => onChange(locale)}
                    overrideInputClassName="sid-change-locale__input"
                    value={value}
                />
            <div className="sid-l-space-btm-sm" />
        </div>
    );
};

export { ChangeLocaleComponent };
